import React from "react";
import { Routes as ReactRoutes, Route, Navigate } from "react-router-dom";
import viewsRoutes from "views/routes";

const Routes = () => {
  return (
    <ReactRoutes>
      {viewsRoutes.map((item, i) => (
        <Route exact key={i} path={item.path} element={item.renderer()} />
      ))}
      <Route path="*" element={<Navigate replace to="/not-found" />} />
    </ReactRoutes>
  );
};

export default Routes;
